module.exports = __webpack_public_path__ + "static/media/iconQuestionMark2.a0b74c81.svg";